import { Button, Card, Col, Row, Spacer, Text } from "@nextui-org/react";
import React, { useCallback } from "react";
import { env } from "resume-builder-v2-common";
import { Icon, Link } from "../components";
import { useResumeDataContext, useSessionContext } from "../context";
import styles from "./home.module.less";
export var Home = function Home() {
  var sessionContext = useSessionContext();
  var isSignedIn = !!sessionContext;

  var _useResumeDataContext = useResumeDataContext(),
      resumes = _useResumeDataContext.resumeEntries;

  var hasCreatedAResume = !!(resumes !== null && resumes !== void 0 && resumes.length);
  var signIn = useCallback(function () {
    location.href = "".concat(env.api, "/login");
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    css: {
      p: "16px"
    }
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
    color: "primary"
  }, /*#__PURE__*/React.createElement(Text, {
    h1: true,
    color: "white"
  }, "Resume Builder"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Text, {
    size: 15,
    color: "white"
  }, "Resume Builder enables you to fully digitize your resume, customize it to your liking, and produce a high-quality printable version that will impress your next employer!")))), /*#__PURE__*/React.createElement(Spacer, null), !isSignedIn && /*#__PURE__*/React.createElement(Row, {
    css: {
      p: "16px",
      gap: "16px"
    }
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
    color: "gradient"
  }, /*#__PURE__*/React.createElement(Text, {
    h2: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "user"
  }), " Sign In or Sign Up"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Text, null, "Sign in to continue editing your resume or sign up now to start!"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Row, {
    css: {
      gap: "8px"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    auto: true,
    color: "primary",
    onClick: signIn
  }, "Sign in"), /*#__PURE__*/React.createElement(Button, {
    auto: true,
    color: "primary",
    onClick: signIn
  }, "Sign up"))))), isSignedIn && /*#__PURE__*/React.createElement(Row, {
    css: {
      p: "16px",
      gap: "16px"
    },
    className: styles.flexWrap
  }, hasCreatedAResume && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
    color: "secondary"
  }, /*#__PURE__*/React.createElement(Text, {
    h2: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "list-check"
  }), " Manage"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Text, null, "Manage, rename, and delete your resumes. You can even see how many views they've had!"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Link, {
    to: "/resumes",
    color: "text"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "circle-chevron-right"
  }), "Resume Manager"))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
    color: "success"
  }, /*#__PURE__*/React.createElement(Text, {
    h2: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "screwdriver-wrench"
  }), " Build"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Text, null, "Use our simple and fast editor to create your resume!"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Link, {
    to: "/interactive",
    color: "text"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "circle-chevron-right"
  }), "Interactive Resume Editor"))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Card, {
    color: "warning"
  }, /*#__PURE__*/React.createElement(Text, {
    h2: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "gear"
  }), " My Account"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Text, null, "Update your preferences"), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Link, {
    to: "/my-account",
    color: "text"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "circle-chevron-right"
  }), "My Account")))));
};